import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	defaultPlaceholder: {
		id: 'command-palette-integration.default-placeholder',
		defaultMessage: 'Search actions, settings, or type "/" to search work',
		description: 'The default placeholder message displayed when the command palette opens',
	},
	noResultsFound: {
		id: 'command-palette-integration.no-results-found',
		defaultMessage: 'No commands match your search.',
		description:
			'When searching in command palette and no results are found, this message will be displayed',
	},
	onErrorFallback: {
		id: 'command-palette-integration.on-error-fallback',
		defaultMessage: "We're having trouble loading this data. Wait a few moments, then try again.",
		description:
			'When there is an error loading the commands in the command palette, this message will be displayed',
	},
	recommendedSection: {
		id: 'command-palette-integration.recommended-section',
		defaultMessage: 'Recommended',
		description: 'Section title for Recommended commands',
	},
	defaultSearchInputAriaLabel: {
		defaultMessage: 'Search actions, settings, or type forward slash to search work',
		id: 'command-palette-integration.default-search-input-aria-label',
		description: 'Aria label for the command palette search input',
	},
});
